/**
 * Render functions and option lists for the AssignmentResource table.
 * Extracted from `AssignmentResource.tsx` to keep the resource declaration thin
 * (ADR-002 §І-4 — no >5-line render logic inside a Resource).
 *
 * Status labels/colors are derived from `Contracts/AssignmentStatus` —
 * the canonical source for the whole container (drawer badge, timeline, cells).
 */

import { StatusBadge } from '@/Ship/Components/UI/StatusBadge/StatusBadge'

import { ASSIGNMENT_STATUS_MAP, type AssignmentStatus } from '../Contracts/AssignmentStatus'
import { delayStatusOption } from '../Contracts/DelayStatus'

export const ASSIGNMENT_STATUS_OPTIONS = (Object.keys(ASSIGNMENT_STATUS_MAP) as AssignmentStatus[]).map((value) => ({
    value,
    label: ASSIGNMENT_STATUS_MAP[value].label,
    color: ASSIGNMENT_STATUS_MAP[value].color,
}))

export const renderStatusTag = (v: any) => {
    const opt = ASSIGNMENT_STATUS_OPTIONS.find((o) => o.value === v)
    if (!opt) return v || '—'
    const hex = opt.color.replace('#', '')
    const r = parseInt(hex.slice(0, 2), 16)
    const g = parseInt(hex.slice(2, 4), 16)
    const b = parseInt(hex.slice(4, 6), 16)
    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: `rgba(${r},${g},${b},0.85)`,
                color: '#ffffff',
                border: `1px solid rgba(${r},${g},${b},1)`,
                borderRadius: '4px',
                padding: '2px 8px',
                fontSize: 13,
                fontWeight: 400,
            }}
        >
            {opt.label}
        </span>
    )
}

/** Черговість показу, коли затримок кілька: спершу нова, потім ескальована, далі закриті */
const DELAY_PRIORITY: Record<string, number> = { received: 0, escalated: 1, resolved: 2 }

/**
 * Комірка «Затримка виконання»: бейдж найактуальнішої затримки (див. DELAY_PRIORITY)
 * у стилі статусу задачі (Ship StatusBadge); без затримок — «—»
 */
export const renderDelayStatus = (_: unknown, row: any) => {
    const delays: Array<{ status?: string }> = Array.isArray(row?.delays) ? row.delays : []
    if (delays.length === 0) return '—'
    const current = delays.reduce((prev, curr) =>
        (DELAY_PRIORITY[curr.status ?? ''] ?? 99) < (DELAY_PRIORITY[prev.status ?? ''] ?? 99) ? curr : prev
    )
    return <StatusBadge option={delayStatusOption(current.status)} fallbackLabel={current.status ?? '—'} />
}
